<nav class="h-full w-96 rounded-md bg-shs-gray-5 pb-8 pt-6 px-6">
    <div class="flex flex-col">
        <div class="grid grid-cols-[32px_auto] gap-2 group" [attr.data-active]="step() >= 1">
            <div
                class="flex h-8 w-8 items-center justify-center rounded-full border-[1.5px] border-shs-gray-3 group-data-[active=true]:border-shs-orange"
            >
                <div class="h-3 w-3 rounded-full bg-shs-gray-3 group-data-[active=true]:bg-shs-orange"></div>
            </div>
            <p class="flex items-center text-base font-bold text-shs-gray-1 group-data-[active=true]:text-font-primary">
                COD Creation
            </p>
        </div>

        <div class="grid grid-cols-[32px_auto] gap-2 group" [attr.data-active]="step() >= 1">
            <div class="flex flex-col items-center justify-center">
                <div class="h-12 w-px bg-shs-gray-3 group-data-[active=true]:bg-shs-orange"></div>
            </div>
            <div></div>
        </div>

        <div class="grid grid-cols-[32px_auto] gap-2 -mt-2 -mb-2 z-10 group" [attr.data-active]="step() >= 1">
            <div class="flex flex-col items-center justify-center">
                <div
                    class="h-3 w-3 rounded-full border bg-shs-gray-5 group-data-[active=true]:bg-shs-orange border-shs-gray-3 group-data-[active=true]:border-shs-orange"
                ></div>
            </div>
            <p class="flex items-center text-base text-shs-gray-1 group-data-[active=true]:text-font-primary">
                General Information
            </p>
        </div>

        <div class="grid grid-cols-[32px_auto] gap-2 group" [attr.data-active]="step() >= 2">
            <div class="flex flex-col items-center justify-center">
                <div class="h-12 w-px bg-shs-gray-3 group-data-[active=true]:bg-shs-orange"></div>
            </div>
            <div></div>
        </div>

        <div class="grid grid-cols-[32px_auto] gap-2 -mt-2 -mb-2 z-10 group" [attr.data-active]="step() >= 2">
            <div class="flex flex-col items-center justify-center">
                <div
                    class="h-3 w-3 rounded-full border bg-shs-gray-5 group-data-[active=true]:bg-shs-orange border-shs-gray-3 group-data-[active=true]:border-shs-orange"
                ></div>
            </div>
            <p class="flex items-center text-base text-shs-gray-1 group-data-[active=true]:text-font-primary">
                Order Details
            </p>
        </div>

        <div class="grid grid-cols-[32px_auto] gap-2 group" [attr.data-active]="step() >= 3">
            <div class="flex flex-col items-center justify-center">
                <div class="h-12 w-px bg-shs-gray-3 group-data-[active=true]:bg-shs-orange"></div>
            </div>
            <div></div>
        </div>

        <div class="grid grid-cols-[32px_auto] gap-2 group" [attr.data-active]="step() >= 3">
            <div
                class="flex h-8 w-8 items-center justify-center rounded-full border-[1.5px] border-shs-gray-3 group-data-[active=true]:border-shs-orange"
            >
                <div class="h-3 w-3 rounded-full bg-shs-gray-3 group-data-[active=true]:bg-shs-orange"></div>
            </div>
            <p class="flex items-center text-base font-bold text-shs-gray-1 group-data-[active=true]:text-font-primary">
                Nature of Complaint
            </p>
        </div>

        <div class="grid grid-cols-[32px_auto] gap-2 group" [attr.data-active]="step() >= 3">
            <div class="flex flex-col items-center justify-center">
                <div class="h-12 w-px bg-shs-gray-3 group-data-[active=true]:bg-shs-orange"></div>
            </div>
            <div></div>
        </div>

        <div class="grid grid-cols-[32px_auto] gap-2 -mt-2 -mb-2 z-10 group" [attr.data-active]="step() >= 3">
            <div class="flex flex-col items-center justify-center">
                <div
                    class="h-3 w-3 rounded-full border bg-shs-gray-5 group-data-[active=true]:bg-shs-orange border-shs-gray-3 group-data-[active=true]:border-shs-orange"
                ></div>
            </div>
            @if (step() >= 3) {
            <p class="flex items-center text-base text-shs-gray-1 group-data-[active=true]:text-font-primary">
                Affected Items
            </p>
            } @else {
            <div class="w-2/3 h-5 rounded-md bg-gradient-to-r from-shs-gray-4 to-shs-gray-5 animate-pulse"></div>
            }
        </div>

        <div class="grid grid-cols-[32px_auto] gap-2 group" [attr.data-active]="step() >= 4">
            <div class="flex flex-col items-center justify-center">
                <div class="h-12 w-px bg-shs-gray-3 group-data-[active=true]:bg-shs-orange"></div>
            </div>
            <div></div>
        </div>

        <div class="grid grid-cols-[32px_auto] gap-2 -mt-2 -mb-2 z-10 group" [attr.data-active]="step() >= 4">
            <div class="flex flex-col items-center justify-center">
                <div
                    class="h-3 w-3 rounded-full border bg-shs-gray-5 group-data-[active=true]:bg-shs-orange border-shs-gray-3 group-data-[active=true]:border-shs-orange"
                ></div>
            </div>
            @if (step() >= 3) {
            <p class="flex items-center text-base text-shs-gray-1 group-data-[active=true]:text-font-primary">
                Additional Information
            </p>
            } @else {
            <div class="w-2/3 h-5 rounded-md bg-gradient-to-r from-shs-gray-4 to-shs-gray-5 animate-pulse"></div>
            }
        </div>

        <div class="grid grid-cols-[32px_auto] gap-2 group" [attr.data-active]="step() >= 5">
            <div class="flex flex-col items-center justify-center">
                <div class="h-12 w-px bg-shs-gray-3 group-data-[active=true]:bg-shs-orange"></div>
            </div>
            <div></div>
        </div>

        <div class="grid grid-cols-[32px_auto] gap-2 group" [attr.data-active]="step() >= 5">
            <div
                class="flex h-8 w-8 items-center justify-center rounded-full border-[1.5px] border-shs-gray-3 group-data-[active=true]:border-shs-orange"
            >
                <div class="h-3 w-3 rounded-full bg-shs-gray-3 group-data-[active=true]:bg-shs-orange"></div>
            </div>
            <p class="flex items-center text-base font-bold text-shs-gray-1 group-data-[active=true]:text-font-primary">
                Summary
            </p>
        </div>

        <div class="grid grid-cols-[32px_auto] gap-2 group" [attr.data-active]="step() >= 5">
            <div class="flex flex-col items-center justify-center">
                <div class="h-12 w-px bg-shs-gray-3 group-data-[active=true]:bg-shs-orange"></div>
            </div>
            <div></div>
        </div>

        <div class="grid grid-cols-[32px_auto] gap-2 -mt-2 -mb-2 z-10 group" [attr.data-active]="step() >= 5">
            <div class="flex flex-col items-center justify-center">
                <div
                    class="h-3 w-3 rounded-full border bg-shs-gray-5 group-data-[active=true]:bg-shs-orange border-shs-gray-3 group-data-[active=true]:border-shs-orange"
                ></div>
            </div>
            @if (step() >= 5) {
            <p class="flex items-center text-base text-shs-gray-1 group-data-[active=true]:text-font-primary">
                COD Overview
            </p>
            } @else {
            <div class="w-2/3 h-5 rounded-md bg-gradient-to-r from-shs-gray-4 to-shs-gray-5 animate-pulse"></div>
            }
        </div>

        <div class="grid grid-cols-[32px_auto] gap-2 group" [attr.data-active]="step() >= 6">
            <div class="flex flex-col items-center justify-center">
                <div class="h-12 w-px bg-shs-gray-3 group-data-[active=true]:bg-shs-orange"></div>
            </div>
            <div></div>
        </div>

        <div class="grid grid-cols-[32px_auto] gap-2 -mt-2 -mb-2 z-10 group" [attr.data-active]="step() >= 6">
            <div class="flex flex-col items-center justify-center">
                <div
                    class="h-3 w-3 rounded-full border bg-shs-gray-5 group-data-[active=true]:bg-shs-orange border-shs-gray-3 group-data-[active=true]:border-shs-orange"
                ></div>
            </div>
            @if (step() >= 5) {
            <p class="flex items-center text-base text-shs-gray-1 group-data-[active=true]:text-font-primary">
                Submitted
            </p>
            } @else {
            <div class="w-2/3 h-5 rounded-md bg-gradient-to-r from-shs-gray-4 to-shs-gray-5 animate-pulse"></div>
            }
        </div>
    </div>
</nav>
